/**
 * Copy from Figma "Dictionary / Word Rules". The Add a word field and the fix popover word the
 * too-long and no-letter cases differently, so each keeps its own.
 */
export const WORD_RULE_MESSAGES = {
  hasSpace: "Words can't contain spaces. Add each word separately.",
  hasComma: "Words can't contain commas.",
  tooLong: 'A word can be up to 50 characters.',
  numbersOnly: 'A word needs at least one letter.',
  symbolsOnly: 'Words need at least one letter.',
  /** The fix popover's wording for a flagged word too long to add. */
  popoverTooLong: 'Words can be up to 50 characters.',
} as const
